import(/* webpackMode: "eager", webpackExports: ["Scta"] */ "/home/runner/work/rimo-frontend/rimo-frontend/libs/frontend/src/pages/Scta.tsx");
;
import(/* webpackMode: "eager" */ "/home/runner/work/rimo-frontend/rimo-frontend/libs/i18n/src/client.ts");
